import axios from 'axios';
import store from '../../store/index';

export default {
	getAdapters(showDeleted) {
		return axios.get(`${store.state.tenant.tenant?.name}/api/adapters?deleted=${showDeleted}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	editAdapter(adapter) {
		return axios.patch(`${store.state.tenant.tenant?.name}/api/adapters/${adapter.id}`, adapter, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	createAdapter(adapter) {
		return axios.post(`${store.state.tenant.tenant?.name}/api/adapters`, adapter, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	deleteAdapter(adapter) {
		return axios.delete(`${store.state.tenant.tenant?.name}/api/adapters/${adapter.id}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	undeleteAdapter(adapter) {
		return axios.post(
			`${store.state.tenant.tenant?.name}/api/adapters/${adapter.id}/restore`,
			{},
			{
				headers: {
					Authorization: `Bearer ${store.state.auth.token}`,
				},
			}
		);
	},
	loadAdapter(id) {
		return axios.get(`${store.state.tenant.tenant?.name}/api/adapters/${id}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	runAdapter(id, reset, fix) {
		return axios.post(`${store.state.tenant.tenant?.name}/api/adapters/${id}?reset=${reset}&fix=${fix}`, null, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	getAdapterRuns(id, limit, offset) {
		return axios.get(`${store.state.tenant.tenant?.name}/api/adapters/${id}/adapterruns?limit=${limit}&offset=${offset}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	findAdapterRun(id) {
		return axios.get(`${store.state.tenant.tenant?.name}/api/adapterruns/${id}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	importArchive(id, formData) {
		return axios.patch(`${store.state.tenant.tenant?.name}/api/adapters/importArchive/${id}`, formData, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
				'Content-Type': 'multipart/form-data',
			},
		});
	},
};
